import BaseService from '../service/_base'

class TestService extends BaseService  {
	constructor(name) {
		super(name)
	}
	
	//overwrite 
    test() {
		return {'message':'new overwrite'};
	}
  
};
		
export default new TestService('test');